<template>
    <a-layout-sider width="200" style="background: #fafafa;border-radius: 8px;margin-left: 12px;">
   <a-menu
          v-model:openKeys="openKeys"
          mode="inline"
          :style="{ height: '100%', borderRight: 0, 'border-radius': '8px' }"
          @click="handelClick"
          v-model:selectedKeys="selectedKeys1"
          class="slidermenu"
        >
          <!--a-sub-menu key="sub1">
            <template #title>
              <span>
                <user-outlined />
                小额补偿免退货
              </span>
            </template>
            <a-menu-item class="submenu" key="1" ><router-link to="/">免退货功能介绍</router-link> </a-menu-item>
            <a-menu-item class="submenu" key="2"><router-link to="/SaleDclTh">待处理退货订单</router-link></a-menu-item>
            <a-menu-item class="submenu" key="3"><router-link to="/SaleRenwu">待客服沟通订单</router-link></a-menu-item>
            <a-menu-item class="submenu" key="4"><router-link to="/SaleRMDKPI">日免退货业绩</router-link></a-menu-item>
            <a-menu-item class="submenu" key="SaleSingleKPI"><router-link to="/SaleSingleKPI">客服绩效</router-link></a-menu-item>
            <a-menu-item class="submenu" key="SaleRefundList"><router-link to="/SaleRefundList">小额打款记录</router-link></a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub8">
            <template #title>
              <span>
                <phone-outlined />
                售后业务处理
              </span>
            </template>
            <a-menu-item class="submenu" key="KFSaleDcl" ><router-link to="/KFSaleDcl">待处理售后</router-link> </a-menu-item>
          </a-sub-menu-->
          <a-sub-menu key="zcp">
            <template #title>
              <span>
                <user-outlined />
                中差评处理
              </span>
            </template>
            <a-menu-item class="submenu" key="zcpInfo" ><router-link to="/zcpInfo">使用辅导</router-link> </a-menu-item>
            <a-menu-item class="submenu" key="zcpList"><router-link to="/zcpList">中差评列表</router-link></a-menu-item>
            <a-menu-item class="submenu" key="zcpSuccessList"><router-link to="/zcpSuccessList">已成功隐藏中差评</router-link></a-menu-item>
            <a-menu-item class="submenu" key="AccManage"><router-link to="/AccManage">多店铺管理</router-link></a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub2">
            <template #title>
              <span>
                <laptop-outlined />
                人工邀评升体验分
              </span>
            </template>
            <a-menu-item class="submenu" key="rengongInfo"><router-link to="/rengongInfo"> 使用辅导</router-link></a-menu-item>
            <a-menu-item class="submenu" key="rengongWlq"><router-link to="/rengongWlq">未领取待邀评订单</router-link></a-menu-item>
            <a-menu-item class="submenu" key="RengongYlqRw"><router-link to="/RengongYlqRw">已领取待邀评订单</router-link></a-menu-item>
            <a-menu-item class="submenu" key="RengongCPKPI"><router-link to="/RengongCPKPI">邀评业绩</router-link></a-menu-item>
            <a-menu-item class="submenu" key="RengongGrKPI"><router-link to="/RengongGrKPI">客服邀评绩效</router-link></a-menu-item>
            <a-menu-item class="submenu" key="RengongKfKPI"><router-link to="/RengongKfKPI">评价详情</router-link></a-menu-item>
            <a-menu-item class="submenu" key="RengongCXTool"><router-link to="/RengongCXTool">信息查询工具</router-link></a-menu-item>
            <a-menu-item class="submenu" key="RengongFeigeMessageList"><router-link to="/RengongFeigeMessageList">飞鸽模板</router-link></a-menu-item>
            <a-menu-item class="submenu" key="RengongKFManageDel"><router-link to="/RengongKFManageDel">客服删除</router-link></a-menu-item>
          </a-sub-menu>
         
          <a-sub-menu key="sub3">
            <template #title>
              <span>
                <snippets-outlined />
                短信催好评_防差评
              </span>
            </template>
            <a-menu-item class="submenu" key="SmsSign"><router-link to="/SmsSign">签名管理</router-link></a-menu-item>
            <a-menu-item class="submenu" key="SmsTemplate"><router-link to="/SmsTemplate">模板管理</router-link></a-menu-item>
            <a-menu-item class="submenu" key="SmsCreateNew"><router-link to="/SmsCreateNew">活动创建</router-link></a-menu-item>
            <a-menu-item class="submenu" key="SmslistNew"><router-link to="/SmslistNew">活动列表</router-link></a-menu-item>
            <a-menu-item class="submenu" key="SmsSend"><router-link to="/SmsSend">短信发送</router-link></a-menu-item>
            <a-menu-item class="submenu" key="SmsDonelist"><router-link to="/SmsDonelist">发送记录</router-link></a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub4">
            <template #title>
              <span>
                <container-outlined />
                短信话费
              </span>
            </template>
            <a-menu-item class="submenu" key="SmsFeeChange"><router-link to="/SmsFeeChange">充值话费</router-link></a-menu-item>
            <a-menu-item class="submenu" key="16">其他店铺共享话费</a-menu-item>
            <!--a-menu-item class="submenu" key="SmsFeeSH"><router-link to="/SmsFeeSH">售后业务</router-link></a-menu-item>
            <a-menu-item class="submenu" key="SmsFeeCPCL"><router-link to="/SmsFeeCPCL">差评处理</router-link></a-menu-item-->
          </a-sub-menu>
          <!--a-sub-menu key="sub8">
            <template #title>
              <span>
                <container-outlined />
                售后业务
              </span>
            </template>
            <a-menu-item class="submenu" key="SmsFeeSH"><router-link to="/SmsFeeSH">售后业务</router-link></a-menu-item>
            <a-menu-item class="submenu" key="SmsFeeCPCL"><router-link to="/SmsFeeCPCL">差评处理</router-link></a-menu-item>
            <a-menu-item class="submenu" key="SmsFeeCreate"><router-link to="/SmsFeeCreate">差评短信模版创建</router-link></a-menu-item>
            <a-menu-item class="submenu" key="SmsFeeActList"><router-link to="/SmsFeeActList">差评短信模版列表</router-link></a-menu-item>
          </a-sub-menu-->
          <a-sub-menu key="sub5">
            <template #title>
              <span>
                <printer-outlined />
                打单发货
              </span>
            </template>
            <a-menu-item class="submenu" key="PrintDdy"><router-link to="/PrintDdy">待打印订单</router-link></a-menu-item>
            <a-menu-item class="submenu" key="PrintSubmit"><router-link to="/PrintSubmit">订单发货</router-link></a-menu-item>
            <a-menu-item class="submenu" key="PrintDykdd"><router-link to="/PrintDykdd">已发货订单</router-link></a-menu-item>
            <a-menu-item class="submenu" key="PrintManage"><router-link to="/PrintManage">配置信息</router-link></a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub6">
            <template #title>
              <span>
                <reconciliation-outlined />
                打印设置
              </span>
            </template>
            <a-menu-item class="submenu" key="Dzmdlist"><router-link to="/Dzmdlist">电子面单管理</router-link></a-menu-item>
            <a-menu-item class="submenu" key="DzmdTempMan"><router-link to="/DzmdTempMan">快递单模板</router-link></a-menu-item>
            <!--a-menu-item class="submenu" key="DzmdFHAddress"><router-link to="/DzmdFHAddress">发货地址</router-link></a-menu-item-->
            
          </a-sub-menu>
          <!--a-sub-menu key="sub9">
            <template #title>
              <span>
                <reconciliation-outlined />
                数据统计
              </span>
            </template>
            <a-menu-item class="submenu" key="DataInfo"><router-link to="/DataInfo">店铺利润统计</router-link></a-menu-item>
            <a-menu-item class="submenu" key="DataProPrice"><router-link to="/DataProPrice">商品成本设置</router-link></a-menu-item>
            
          </a-sub-menu-->
          <div style="height:260px;">
          <a-image
          :width="200"
          src="https://wework.qpic.cn/wwpic/907517_PKyxIjfrT6aHhyw_1625555374/0"
        /><br /><br />
        <div style="text-align: center;margin-top: 12px;">微信扫码联系客服<router-link to="/RengongFeigeMessageList" class="colorwhite">1</router-link></div>
      </div>  
        </a-menu>
    </a-layout-sider>
    <a-back-top />
  </template>
  
  <script>
  import {
    LaptopOutlined,
    SnippetsOutlined,
    ContainerOutlined,
    PrinterOutlined,
    ReconciliationOutlined
  } from "@ant-design/icons-vue";
  import { defineComponent, ref } from "vue"; 
  
  export default defineComponent ({  
    
    components: {
      LaptopOutlined,
      SnippetsOutlined,
      ContainerOutlined, 
      PrinterOutlined,
      ReconciliationOutlined
    },
    setup() {
      return {
        collapsed: ref(false),
        openKeys: ref([
            "sub1",
            "sub2",
            "sub3",
            "sub4",
            "sub5",
            "sub6",
            "sub7",
            "sub8",
            "sub9",
            "subfeige",
            "zcp",
			

        ]),      
      };
    },
    data(){
      return{
        selectedKeys1:ref(['1'])
      }
    },
    mounted () {
      this.setMenuCheck() 
    },
    methods:{
      setMenuCheck(){
        let num = this.indexmenu
        this.selectedKeys1 = ref([num]);
        
      }
    },
    props:['indexmenu']
  });
  </script>
  
  <style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  #components-layout-demo-top-side-2 .logo {
    float: left;
    width: 120px;
    height: 31px;
    margin: 16px 24px 16px 0;
    background: rgba(255, 255, 255, 0.3);
    
  }
  
  .ant-row-rtl #components-layout-demo-top-side-2 .logo {
    float: right;
    margin: 16px 0 16px 24px;
  }
  
  .site-layout-background {
    background: #fff;
  }
  .gongsiheader {
    background-color:none;
  }
  .gongsilogo{
    border-radius: 4px;
  }
  .gongsiname {
    font-size: 16px;
    font-weight: 700;
    margin-left: 4px;
  }
  .submenu{
    font-size: 14px;
    color: #252931;
    background-color: #fff;
  }
  .ant-menu-sub.ant-menu-inline {
    background-color: #fff;
  }
  .ant-menu-inline .ant-menu-submenu {
    background-color: #fafafa;
  }
  .colorwhite{
    color:#fff;
  }
  .fudongtip{
	position: relative;color: #fff;background-color: #f00;display: inline-block;padding: 0px 4px;border-radius: 4px;top: -10px;left: 4px;
  }
  </style>
  